module.exports = __webpack_public_path__ + "img/educate-badge.07dc7761.png";